import {DOCUMENT} from '@angular/common';
import {Inject, Injectable} from '@angular/core';
import {environment} from "../../environments/environment";

type GrecaptchaApi = {
  ready(callback: () => void): void;
  execute(siteKey: string, options: {action: string}): Promise<string>;
};

type RecaptchaWindow = Window & {
  grecaptcha?: GrecaptchaApi;
};

@Injectable({
  providedIn: 'root',
})
export class RecaptchaService {
  private loadPromise: Promise<void> | null = null;

  constructor(@Inject(DOCUMENT) private readonly document: Document) {}

  async execute(action: string): Promise<string> {
    if (!environment.recaptcha_site_key) {
      throw new Error('Recaptcha site key is not set.');
    }

    if (this.loadPromise) {
      await this.loadPromise;
    }

    const grecaptcha = (this.document.defaultView as RecaptchaWindow | null)?.grecaptcha;
    if (!grecaptcha) {
      throw new Error('Recaptcha is not available.');
    }

    return new Promise<string>((resolve, reject) => {
      grecaptcha.ready(() => {
        grecaptcha.execute(environment.recaptcha_site_key, {action: action})
          .then(resolve)
          .catch(reject);
      });
    });
  }
}
